import { useQuery } from "@tanstack/react-query";
import {
	type CompanyConfig,
	fetchCompanySettings,
	getCompanyConfig,
} from "~/utils/company-config";

export function useCompanyConfig(tenantId?: string) {
	const { data, isLoading, error } = useQuery({
		queryKey: ["company-settings", tenantId],
		queryFn: () => fetchCompanySettings(tenantId),
		staleTime: 5 * 60 * 1000, // Cache for 5 minutes
		gcTime: 10 * 60 * 1000, // Keep in memory for 10 minutes
		refetchOnWindowFocus: false,
		retry: 1, // Only retry once if failed
	});

	// Return fetched data or fallback to cached/default config
	return {
		companyConfig: data || getCompanyConfig(),
		isLoading,
		error,
	};
}
